import React from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";

const TaxRegime = () => {
    const config: MasterConfigs = {
        api: () => '/tax-regime',
        title: 'Tax Regime',
        modalTitle: () => 'Tax Regime',
        getColumns: () => [
            {
                title: 'Tax Regime',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Tax Regime',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Tax Regime' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    return <MasterComponent config={config} />
}

export default TaxRegime;